import { CommonModule } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import moment from 'moment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToastModule } from 'primeng/toast';
import { environment } from '../../../../../environments/environment';
import { Club } from '../../../../model/Club';
import { HttpResponse } from '../../../../model/HttpResponse';
import { Modalidad } from '../../../../model/Modalidad';
import { Nivel } from '../../../../model/Nivel';
import { Role } from '../../../../model/Role';
import { AcademyAdministratorOperation } from '../../../../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../../../../model/administrator/AcademyAdministratorType';
import { AdministratorEntity } from '../../../../model/administrator/AdministratorEntity';
import { FOTO_GUILLO } from '../../../../model/const/const';
import { GenderType } from '../../../../model/genderType';
import { IdType } from '../../../../model/idType';
import { Member } from '../../../../model/member';
import { AdministrationService } from '../../../../services/administration.service';
import { GestionService } from '../../../../services/gestion.service';
import { LoadingService } from '../../../../services/loading.service';
import { PageHeaderComponent } from '../../../shared/page-header/page-header.component';
import { CrudTableComponent } from '../../../shared/tables/crud-table/crud-table.component';
interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

@Component({
  selector: 'app-member-register',
  standalone: true,
  providers: [MessageService, ConfirmationService],
  imports: [
    PageHeaderComponent,
    CrudTableComponent,
    ConfirmDialogModule,
    ReactiveFormsModule,
    DialogModule,
    InputTextModule,
    CommonModule,
    InputSwitchModule,
    SelectButtonModule,
    CalendarModule,
    DropdownModule,
    InputNumberModule,
    ToastModule,
    AutoCompleteModule,
    FileUploadModule,
    AvatarModule
  ],
  templateUrl: './member-register.component.html',
  styleUrl: './member-register.component.scss',
})
export class MemberRegisterComponent implements OnInit {
  @Input()
  clubes!: Club[];

  @Input()
  idType!: IdType;

  @Input()
  idNumber!: string;

  @Input()
  isUpdateMoment: boolean = false;

  @Input()
  memberToUpdate!: Member;

  @Output()
  memberCreated: EventEmitter<any> = new EventEmitter();

  @Output()
  memberUpdated: EventEmitter<any> = new EventEmitter();

  @Output()
  closeDialogEvent: EventEmitter<any> = new EventEmitter();
  validateForm!: FormGroup;
  showForm: boolean = false;
  isNewForm: boolean = false;
  isUpdateForm: boolean = false;
  dialogHeader?: string;
  stateOptions: any[] = [
    { label: 'Inactiva', value: false },
    { label: 'Activa', value: true },
  ];

  modalidades = [
    { name: 'Artístico', value: Modalidad.ARTISTICO },
    { name: 'Carreras', value: Modalidad.CARRERAS },
    { name: 'Hockey', value: Modalidad.HOCKEY },
    { name: 'Skateboarding', value: Modalidad.SKATEBOARDING },
    { name: 'Inline Downhill', value: Modalidad.INLINE_DOWNHILL },
    { name: 'Inline Freestyle', value: Modalidad.INLINE_FREESTYLE },
  ];

  roles = [
    { name: 'Deportista', value: Role.DEPORTISTA },
    { name: 'Entrenador', value: Role.ENTRENADOR },
    { name: 'Técnico', value: Role.TECNICO },
    { name: 'Delegado', value: Role.DELEGADO },
  ];

  genderTypes = [
    { name: 'Femenino', value: GenderType.FEMENINO },
    { name: 'Masculino', value: GenderType.MASCULINO },
    //{ name: 'No Binario', value: GenderType.NO_BINARIO },
  ];

  idTypes = [
    { name: 'Registro Civil', value: IdType.REGISTRO_CIVIL },
    { name: 'Tarjeta de identidad', value: IdType.TARJETA_IDENTIDAD },
    { name: 'Cédula', value: IdType.CEDULA },
    { name: 'Pasaporte', value: IdType.PASAPORTE },
    { name: 'Cédula de Extranjería', value: IdType.CEDULA_EXTRANGERIA },
    {
      name: 'Documento de Identidad Extranjero',
      value: IdType.IDENTIDAD_EXTRANGERA,
    },
  ];

  levelTypes = [
    { name: 'Liga', value: Nivel.LIGA },
    { name: 'Novato', value: Nivel.NOVATO },
  ];

  rolSelected!: Role;

  userName!: string;
  filteredClubes: any[] = [];
  pictureBase64!: string;
  uploadUrl = `${environment.academyApi.documents}/upload`;
  docsApikey = `${environment.apiManagementConfig.carnetdigitalApi}`;
  docsHeaders = new HttpHeaders({ 'subscription-key': this.docsApikey });
  showPicturePicker: boolean = false;
  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private administrationService: AdministrationService,
    private gestionService: GestionService,
    private loadingService: LoadingService,
    private fb: FormBuilder,
    private msalService: MsalService
  ) {}
  ngOnInit(): void {
    this.userName =
      this.msalService.instance.getActiveAccount()?.idTokenClaims?.name || '';
    if (!this.isUpdateMoment) {
      this.getFormNew();
      this.showForm = true;
    } else {
      this.pictureBase64 = this.memberToUpdate.picture!;
      this.getFormEdit(this.memberToUpdate);
      this.showForm = true;
    }
  }

  getFormNew() {
    this.validateForm = this.fb.group({
      club: [null, Validators.required],
      modalidad: [null, Validators.required],
      rol: [this.rolSelected, [Validators.required]],
      nivel: [null, [Validators.required]],
      idType: [this.idType, [Validators.required]],
      idNumber: [
        this.idNumber,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(10),
        ],
      ],
      name: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      mobile: [
        null,
        [
          Validators.required,
          Validators.minLength(7),
          Validators.maxLength(10),
        ],
      ],
      address: [null, [Validators.required]],
      birthDay: [null, [Validators.required]],
      birthPlace: [null],
      gender: [null, [Validators.required]],
      telephone: [null],
      city: [null],
      neighborhood: [null],
      bloodType: [null, [Validators.maxLength(3), Validators.minLength(2)]],
      insurance: [null, [Validators.required]],
    });
    this.dialogHeader = 'Nueva Vinculación';
    this.isNewForm = true;
    this.isUpdateForm = false;
    this.showForm = true;
  }

  getFormEdit(item: Member) {
    this.validateForm = this.fb.group({
      id: [item.id],
      club: [item.club, Validators.required],
      modalidad: [item.modalidad, Validators.required],
      rol: [item.rol, [Validators.required]],
      nivel: [item.nivel, [Validators.required]],
      idType: [item.idType, [Validators.required]],
      idNumber: [
        item.idNumber,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(10),
        ],
      ],
      name: [item.name, [Validators.required]],
      lastName: [item.lastName, [Validators.required]],
      email: [item.contactInformation.email, [Validators.required, Validators.email]],
      mobile: [
        item.contactInformation.mobile,
        [
          Validators.required,
          Validators.minLength(7),
          Validators.maxLength(10),
        ],
      ],
      address: [item.contactInformation.address, [Validators.required]],
      birthDay: [new Date(item.birthDay), [Validators.required]],
      birthPlace: [item.birthPlace ?? ''],
      gender: [item.gender, [Validators.required]],
      telephone: [item.contactInformation.telephone],
      city: [item.contactInformation.city ?? ''],
      neighborhood: [item.contactInformation.neighborhood ?? ''],
      bloodType: [item.assistanceInformation.bloodType, [Validators.maxLength(3), Validators.minLength(2)]],
      insurance: [item.assistanceInformation.insurance, [Validators.required]],
    });
    this.dialogHeader = `Actualizar información de ${item.name}`;
    this.isNewForm = false;
    this.isUpdateForm = true;
    this.showForm = true;
  }

  closeDialog() {
    this.showForm = false;
    this.closeDialogEvent.emit();
  }

  addNewItem() {
    if (this.validateForm.valid) {
      this.loadingService.showLoading();
      const item = this.buildAcademyItem(this.validateForm.value);
      const entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.CREATE,
        payload: item,
        type: AcademyAdministratorType.MEMBERS,
      };
      this.gestionService.sendRequest(entity).subscribe((res: HttpResponse) => {
        if (res.code === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'OK',
            detail: 'La vinculación se ha creado correctamente!',
            life: 3000,
          });

          this.memberCreated.emit(item);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail:
              'Ocurrió un error creando el registro, inténtelo nuevamente si el error persiste contacte el administrador del sistema',
            life: 3000,
          });
        }
        this.showForm = false;
        this.loadingService.hideLoading();
      });
    } else {
      this.messageService.add({
        severity: 'warning',
        summary: 'Verificar',
        detail:
          'Verifique que todos los campos obligatorios del formulario estén completos',
        life: 3000,
      });
    }
  }

  editExistentItem() {
    this.confirmationService.confirm({
      message: '¿Estas seguro de actualizar este registro?',
      header: 'Confirmar',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.loadingService.showLoading();
        const item = this.buildAcademyItem(this.validateForm.value);
        const entity: AdministratorEntity = {
          operation: AcademyAdministratorOperation.UPDATE,
          payload: item,
          type: AcademyAdministratorType.MEMBERS,
        };
        this.gestionService
          .sendRequest(entity)
          .subscribe((res: HttpResponse) => {
            if (res.code === 200) {
              this.messageService.add({
                severity: 'success',
                summary: 'OK',
                detail: 'El registro se ha actualizado correctamente!',
                life: 3000,
              });
              this.memberUpdated.emit(item);
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail:
                  'Ocurrió un error actualizando el registro, inténtelo nuevamente si el error persiste contacte el administrador del sistema',
                life: 3000,
              });
            }
            this.showForm = false;
            this.loadingService.hideLoading();
          });
      },
    });
  }

  buildAcademyItem(form: any): Member {
    let item: Member = {
      name: form['name'].toUpperCase(),
      lastName: form['lastName'].toUpperCase(),
      idType: form['idType'],
      club: form['club'],
      rol: form['rol'],
      modalidad: form['modalidad'],
      nivel: form['nivel'],
      idNumber: `${form['idNumber']}`,
      birthDay: moment(form['birthDay']).format('YYYY-MM-DD'),
      birthPlace: form['birthPlace'],
      gender: form['gender'],
      picture: this.pictureBase64 || FOTO_GUILLO,
      contactInformation: {
        email: form['email'],
        mobile: form['mobile'],
        telephone: form['mobile'],
        address: form['address']?.toUpperCase(),
        neighborhood: form['neighborhood'],
        city: form['city'],
      },

      assistanceInformation: {
        insurance: form['insurance'],
        bloodType: form['bloodType'],
      },
      memberId: `${form['idType']}${form['idNumber']}`,
      digitalLicense: {
        generated: form['isGeneratedLicense']
          ? form['isGeneratedLicense']
          : false,
        documentId: form['licenseId'] ? form['licenseId'] : '',
        isMigratedMember: false,
      },
      auditData: {
        createdBy: this.isUpdateMoment
          ? this.memberToUpdate.auditData.createdBy
          : this.userName,
        createdDate: this.isUpdateMoment
          ? this.memberToUpdate.auditData.createdDate
          : moment().format('YYYY-MM-DD HH:mm:ss'),
        modifiedBy: this.isUpdateMoment ? this.userName : '',
        modifiedDate: this.isUpdateMoment
          ? moment().format('YYYY-MM-DD HH:mm:ss')
          : '',
      },
      isActive: true,
    };

    if (form['id']) {
      item.id = form['id'];
    }

    return item;
  }

  filterClub(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.clubes as any[]).length; i++) {
      let country = (this.clubes as any[])[i];
      if (country.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(country);
      }
    }

    this.filteredClubes = filtered;
  }

  onSelect(event: any) {
    let fileReader = new FileReader();
    fileReader.readAsDataURL(event.currentFiles[0]);
    fileReader.onload = () => {
      // Will print the base64 here.
      this.pictureBase64 = fileReader.result as string;
    };
    
  }
  onUpload(event: any) {
    let fileReader = new FileReader();
    for (let file of event.files) {
      fileReader.readAsDataURL(file);
      fileReader.onload = function () {
        // Will print the base64 here.
        console.log(fileReader.result);
      };
    }
  }

  changePicture(){
    this.showPicturePicker = true;
  }
}
